import { API_URL } from '../../../../../../services/config';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { AllocationViewEndpoint } from '../../constants';
import { AllocationViewActionIdentifierModel, AllocationViewSealPictureControlModel } from '../../models';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AllocationViewPerformSealPictureControlActionService {
  constructor(private http: WrapperHttpService) {}

  sealCheck(data: AllocationViewSealPictureControlModel): Observable<void> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.SealCheck}`;

    return this.http.withLoading().post<void>(url, data);
  }

  sealCheckPrepare(
    actionIdentifier: AllocationViewActionIdentifierModel,
    currentLanguage: string,
  ): Observable<AllocationViewSealPictureControlModel> {
    const url = `${API_URL}${AllocationViewEndpoint.Action}${AllocationViewEndpoint.SealCheck}${AllocationViewEndpoint.Prepare}?lang=${currentLanguage}`;

    return this.http.withLoading().post<AllocationViewSealPictureControlModel>(url, actionIdentifier);
  }
}
